export default __webpack_public_path__ + "static/media/detail_big_14_3.9939e1b2.jpg";